<template>
    <div>
        <button
            v-if="isAdmin && !isEditing"
            v-t="'Buttons.edit'"
            style="position: sticky; top: 2rem; left: 2rem; z-index: 2"
            class="button"
            @click="isEditing = true"
        ></button>
        <button
            v-if="isAdmin && !isEditing && false === content.published"
            v-t="'Buttons.publish'"
            style="position: sticky; top: 2rem; left: 8rem; z-index: 2"
            class="button is-primary"
            @click="publishActivity"
        ></button>
        <button
            v-if="isAdmin && !isEditing && true === content.published"
            v-t="'Buttons.unpublish'"
            style="position: sticky; top: 2rem; left: 8rem; z-index: 2"
            class="button is-danger"
            @click="unpublishActivity"
        ></button>
        <button
            v-if="isAdmin && isEditing"
            v-t="'Buttons.save'"
            style="position: sticky; top: 2rem; left: 2rem; z-index: 2"
            class="button is-pink-red"
            @click="updateActivity"
        ></button>

        <section class="section">
            <div class="columns is-centered">
                <div class="column is-12">
                    <div :class="{ 'is-loading': !content }" class="box my-6">
                        <p
                            v-if="content"
                            class="title has-text-centered is-size-4"
                        >{{ content.title }}</p>
                        <grid-layout
                            v-if="content"
                            ref="grid"
                            :layout.sync="layout"
                            :col-num="12"
                            :row-height="rowHeight"
                            :margin="[2, 2]"
                            :is-draggable="isEditing"
                            :is-resizable="isEditing"
                            :use-css-transforms="true"
                            :responsive="true"
                            :breakpoints="{
                                lg: 740,
                                md: 475,
                                sm: 400,
                                xs: 342,
                                xxs: 0,
                            }"
                            :cols="{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 3 }"
                            @breakpoint-changed="breakpointChangedEvent"
                        >
                            <grid-item
                                v-for="(item, index) in layout"
                                :key="index"
                                :preserve-aspect-ratio="false"
                                :class="{ 'is-editing': isEditing }"
                                :auto-size="true"
                                :x="item.x"
                                :y="item.y"
                                :w="item.w"
                                :h="item.h"
                                :i="item.i"
                                :min-w="item.type == 'audio' ? 4 : 1"
                                :drag-ignore-from="'a,button'"
                                class="lb-activity-element"
                            >
                                <div
                                    v-if="isEditing"
                                    class="buttons has-addons"
                                    style="
                                        position: absolute;
                                        top: 0px;
                                        right: 4px;
                                        z-index: 2;
                                    "
                                >
                                    <button class="button" @click="removeItem({ index })">
                                        <span class="icon is-small">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </span>
                                    </button>
                                    <button
                                        v-if="item.type != 'separator'"
                                        class="button"
                                        @click="editItem(item)"
                                    >
                                        <span class="icon is-small">
                                            <i class="fas fa-edit" />
                                        </span>
                                    </button>
                                    <button class="button" @click="cloneItem(item)">
                                        <span class="icon is-small">
                                            <i class="fas fa-clone" />
                                        </span>
                                    </button>
                                </div>
                                <input-rich-text
                                    v-if="item.type == 'content'"
                                    :ref="item._id"
                                    v-model="item.content"
                                    :advanced-options="true"
                                    :editable="false"
                                    @resize="resizeItem(item, $event)"
                                />

                                <activity-image-widget
                                    v-else-if="item.type == 'image'"
                                    v-model="item.content"
                                    @resize="resizeItem(item, $event)"
                                />
                                <a
                                    v-else-if="item.type == 'link'"
                                    :href="item.content.url"
                                    class="lb-button is-primary is-fullwidth"
                                    target="_blank"
                                >{{ item.content.title }}</a>
                                <vue-plyr
                                    v-else-if="item.type == 'video'"
                                    :key="extractVideoId(item.content)"
                                >
                                    <div class="plyr__video-embed">
                                        <iframe
                                            :src="`https://www.youtube.com/embed/${extractVideoId(
                                                item.content
                                            )}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
                                            allowfullscreen
                                            allowtransparency
                                            allow="autoplay"
                                        />
                                    </div>
                                </vue-plyr>
                                <div v-else-if="item.type == 'audio'" class="level">
                                    <audio :src="item.content.url" controls class="level-item" />
                                </div>
                                <a
                                    v-else-if="item.type == 'file'"
                                    :href="item.content.url"
                                    class="lb-button is-primary is-fullwidth"
                                    target="_blank"
                                >
                                    <span class="icon">
                                        <i
                                            :class="
                                                item.content.mimeType
                                                    | iconForMime
                                            "
                                            class="fas"
                                        />
                                    </span>
                                    <span>{{ item.content.name }}</span>
                                </a>
                                <div v-else-if="item.type == 'embed'" v-html="item.content"></div>
                                <!--a
                  v-else-if="
                    item.type == 'file' && isPDF(item.content.mimeType)
                  "
                  class="lb-button is-primary is-fullwidth"
                  @click="handleFileClick(item.content.url)"
                >
                  <span class="icon">
                    <i
                      :class="item.content.mimeType | iconForMime"
                      class="fas"
                    />
                  </span>
                  <span>{{ item.content.name }}</span>
                                </a-->

                                <hr v-else-if="item.type == 'separator'" />
                            </grid-item>
                        </grid-layout>
                    </div>
                </div>
                <input-modal
                    v-if="showInputModal"
                    v-model="editingItem.content"
                    :component-type="inputComponentType"
                    :active.sync="showInputModal"
                    :placeholder="$t(`creation.${componentType}_placeholder`)"
                    @input="addGridItem"
                />
                <!--app-document-preview
          v-if="documentURL"
          :document-url="documentURL"
          @close="documentURL = undefined"
                /-->
            </div>
            <div
                v-if="isAdmin && isEditing"
                class="buttons is-centered px-2 has-background-white has-shadow py-2"
                style="
                    position: fixed;
                    bottom: 0;
                    margin-left: -1.5rem;
                    margin-right: 0rem;
                    width: 100%;
                "
            >
                <button
                    v-t="'creation.url'"
                    class="button is-primary is-outlined"
                    @click="addLinkGridItem"
                ></button>
                <button
                    v-t="'creation.content'"
                    class="button is-primary is-outlined"
                    @click="addContentGridItem"
                ></button>
                <button
                    v-t="'creation.image'"
                    class="button is-primary is-outlined"
                    @click="addImageGridItem"
                ></button>
                <button
                    v-t="'creation.audio'"
                    class="button is-primary is-outlined"
                    @click="addAudioGridItem"
                ></button>
                <button
                    v-t="'creation.video'"
                    class="button is-primary is-outlined"
                    @click="addVideoGridItem"
                ></button>
                <button
                    v-t="'creation.file'"
                    class="button is-primary is-outlined"
                    @click="addFileGridItem"
                ></button>
                <button
                    v-t="'creation.embed'"
                    class="button is-primary is-outlined"
                    @click="addEmbedGridItem"
                ></button>
                <button
                    v-t="'creation.separator'"
                    class="button is-primary is-outlined"
                    @click="addSeparatorGridItem"
                ></button>
            </div>
        </section>
    </div>
</template>
<script>
import _ from 'underscore';
import { mapActions } from 'vuex';
import { BAIN_TAGS } from '@/lib/constants';
import InputRichText from '@/components/InputRichText';
import ActivityImageWidget from '@/components/ActivityImageWidget';
import InputModal from '@/components/InputModal';
//import AppDocumentPreview from "@/components/AppDocumentPreview";
import { GridLayout, GridItem } from 'vue-grid-layout';
import { guid } from '@/store/modules/activity/lib';
import { EventBus } from '@/services/event-bus';
export default {
    components: {
        InputRichText,
        ActivityImageWidget,
        GridLayout,
        GridItem,
        InputModal,
        //  AppDocumentPreview,
    },
    filters: {
        iconForMime(mime) {
            if (mime.indexOf('pdf') > -1) {
                return 'fa-file-pdf';
            }
            if (mime.indexOf('image') > -1) {
                return 'fa-image';
            }
            if (mime.indexOf('audio') > -1) {
                return 'fa-file-audio';
            }

            return 'fa-file';
        },
    },
    props: {
        isCreation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            componentType: null,
            showInputModal: false,
            contentInput: null,
            isEditing: false,
            editingItem: {},
            breakpoint: null,
            rowHeight: 42,
            editionMode: false,
            documentURL: undefined,
        };
    },
    computed: {
        totalHeight() {
            return _.reduce(this.layout, (memo, item) => memo + item.h, 0);
        },
        isAdmin() {
            return this.$store.getters.community.accessLevel == 'administrator';
        },
        inputComponentType() {
            switch (this.componentType) {
                case 'link':
                    return 'urlButton';
                    break;
                case 'image':
                    return 'singleImage';
                case 'file':
                    return 'fileButton';
                    break;
                default:
                    return this.componentType;
            }
        },
        content() {
            return _.findWhere(this.$store.getters.communityActivities, {
                _id: this.$route.params.activityId,
            });
        },
        layout: {
            get() {
                return this.content.layout;
            },
            set(layout) {
                this.content.layout = layout;
            },
        },
    },
    watch: {
        showInputModal() {
            if (!this.showInputModal) {
                this.editingItem = {};
                this.editionMode = false;
            }
        },
        content: {
            deep: true,
            handler() {
                this.$store.commit('SET_ACTIVE_FOLDER', this.content.folder);
            },
        },
    },
    async mounted() {
        this.$store.dispatch('fetchResources');
    },
    metaInfo() {
        let zoneTitle = this.$t(`Community.activity.new`);
        if (this.content.title) {
            zoneTitle = this.content.title;
        }
        return {
            title: zoneTitle + ' - ' + this.$store.getters.community.title,
            titleTemplate: '%s - Labylok',
        };
    },
    methods: {
        ...mapActions([
            'addLinkGridItem',
            'addContentGridItem',
            'addImageGridItem',
            'removeItem',
        ]),
        tagCategory(tag) {
            const tagInfo = _.find(BAIN_TAGS, (tagInfo) => {
                return tagInfo.value == tag;
            });
            return tagInfo.category;
        },
        extractVideoId(url) {
            return this.$youtube.getIdFromUrl(url);
        },
        resizeItem(item, { height, width }) {
            if (width) {
                item.h = (item.w * height) / width;
                item.w = Math.round((width * item.h) / height);
            } else {
                item.h = Math.max(Math.round(height / this.rowHeight), item.h);
            }
            this.$refs.grid.layoutUpdate();
        },
        removeItem({ index }) {
            if (index > -1) {
                this.layout.splice(index, 1);
            }
        },
        editItem(item) {
            let { type } = item;
            this.editingItem = item;
            this.showInputModal = true;
            this.componentType = type;
            this.editionMode = true;
        },
        cloneItem(item) {
            this.layout.push({
                ...item,
                ...{
                    y: this.totalHeight + 1,
                    i: guid(),
                },
            });
        },
        addGridItem(content) {
            this.showInputModal = false;
            if (!this.editionMode) {
                let height = 2;
                if (this.componentType == 'content') {
                    height = 1;
                } else if (
                    this.componentType == 'video' ||
                    this.componentType === 'embed'
                ) {
                    height = 10;
                }

                this.layout.push({
                    x: 0,
                    y: this.totalHeight + 1,
                    w: this.componentType == 'link' ? 6 : 12,
                    h: height,
                    i: guid(),
                    type: this.componentType,
                    content,
                });
            } else {
                this.editingItem.content = content;
            }
            this.componentType = null;
        },
        addLinkGridItem() {
            this.componentType = 'link';
            this.showInputModal = true;
        },
        addVideoGridItem() {
            this.componentType = 'video';
            this.showInputModal = true;
        },
        addAudioGridItem() {
            this.componentType = 'audio';
            this.showInputModal = true;
        },

        addImageGridItem() {
            this.layout.push({
                x: 0,
                y: this.totalHeight + 1,
                w: 6,
                h: 2,
                i: guid(),
                type: 'image',
            });
        },
        addContentGridItem() {
            this.componentType = 'content';
            this.showInputModal = true;
        },
        addSeparatorGridItem() {
            this.layout.push({
                x: 0,
                y: this.totalHeight + 1,
                w: 12,
                h: 1,
                i: guid(),
                type: 'separator',
            });
        },
        addFileGridItem() {
            this.componentType = 'file';
            this.showInputModal = true;
        },
        addEmbedGridItem() {
            this.componentType = 'embed';
            this.showInputModal = true;
        },
        breakpointChangedEvent(newBreakpoint, newLayout) {
            this.breakpoint = newBreakpoint;
            EventBus.$emit('layout:changed');
        },
        updateActivity() {
            this.$store
                .dispatch('updateActivity', {
                    object: { ...this.content, layout: this.layout },
                    id: this.$route.params.communityId,
                })
                .then(() => {
                    this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error updating', e);
                    alert(e);
                    return;
                });
        },
        publishActivity() {
            this.$store
                .dispatch('publishActivity', {
                    communityId: this.$route.params.communityId,
                    activityId: this.content._id,
                })
                .then(() => {
                    console.log('published. should we replace the id?');
                    this.content.published = true;
                    //this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error publishing', e);

                    alert(e);
                    return;
                });
        },
        unpublishActivity() {
            this.$store
                .dispatch('unpublishActivity', {
                    communityId: this.$route.params.communityId,
                    activityId: this.content._id,
                })
                .then(() => {
                    console.log('unpublished');
                    this.content.published = false;
                    //this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error unpublishing', e);
                    alert(e);
                    return;
                });
        },
        handleFileClick(url) {
            this.documentURL = url;
            console.log('file click', url, this.documentURL);
        },
    },
};
</script>
<style scoped>
.lb-activity-element {
    padding: 0.75rem;
    overflow: hidden;
}
.lb-activity-element.is-editing {
    border: dashed 1px grey;
}
.vue-grid-item.lb-activity-element.cssTransforms
    .lb-button.is-primary.is-fullwidth {
    height: auto;
    white-space: normal;
    max-height: -webkit-fill-available;
}
</style>
